module.exports = __webpack_public_path__ + "img/header-4.514e754.jpg";